var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightDisabled = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "keyboard_arrow_right"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_161",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 24,
  height: 24
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 24,
  height: 24,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_161)"
}, /*#__PURE__*/React.createElement("path", {
  id: "keyboard_arrow_right_2",
  d: "M12.6 12L8 7.4L9.4 6L15.4 12L9.4 18L8 16.6L12.6 12Z",
  fill: "#999E9C"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-right-disabled.52d25308d73887ee2d49b5a4b0838520.svg";